<template>
    <div class="dir-tree">
        <div class="title-bar" v-if="showTitleBar">
            <span class="title">{{ title }}</span>
            <span class="ctrl-blk">
                <el-input v-if="showFilterBox" class="filter" size="mini" style="width: 80px;" clearable placeholder="关键字过滤"
                          @change="doNodeFilter"
                          v-model="filterText">
                </el-input>
                <span v-if="topActionsMaker != null" style="margin-left: 4px;">
                      <el-link v-for="action in topActionsMaker(viewMode)" :disabled="action.disabled" style="margin-left: 6px; margin-right: 4px;" @click="doTopActionCmd(action.name, action)">
                          <span v-if="action.icon" :title="(action.hint || action.text)">
                                <i :class="action.icon"></i>
                          </span>
                          <span>{{ action.text }}</span>
                      </el-link>
                </span>
            </span>
        </div>
        <el-tree class="tree-ctrl" :class="{'noTitleBar' : !showTitleBar}" ref="theTree"
                 :expandOnClickNode="false"
                 :data="itemList"
                 :node-key="nodeKeyProp"
                 :empty-text="emptyText"
                 :props="treeProps"
                 :default-expand-all="defaultExpandAll"
                 :show-checkbox="nodeCheckable"
                 :highlight-current="highlightCurrent"
                 :filter-node-method="filterTreeNode"
                 @current-change="handleCurrentChange"

                 :draggable="nodeDraggable"
                 @node-click="handleNodeClick"
                 @node-drag-start="handleDragStart"
                 @node-drag-enter="handleDragEnter"
                 @node-drag-over="handleDragOver"
                 @node-drag-leave="handleDragLeave"
                 @node-drag-end="handleDragEnd"
                 @node-drop="handleDrop"
                 :allow-drag="allowDragJudger"
                 :allow-drop="allowDropJudger"
        >
            <span class="tree-node" slot-scope="{ node, data }">
                <span>
                    <i :class="nodeClassMaker(data , node, viewMode)" style="margin-right: 4px;font-size: 16px"></i>
                    <label class="label" :class="{'current' : node.isCurrent && highlightCurrent}" :title="node.label">{{ node.label }}</label>
                </span>
                <span v-if="nodeActionsMaker != null" v-show="shouldShowNodeActions(node)">
                      <span v-if="showNodeActionsAsBtns">
                          <el-link v-for="action in nodeActionsMaker(data , node, viewMode)" :disabled="action.disabled" style="margin-right: 4px;" @click="doNodeActionCmd(action.name, node, action)">
                              <span v-if="action.icon" :title="action.text">
                                    <i :class="action.icon"></i>
                              </span>
                              <span v-else>{{ action.text }}</span>
                          </el-link>
                      </span>
                      <swb-ext-dropdown v-else :dropClassName="'el-icon-s-operation'" :items="nodeActionsMaker(data , node, viewMode)"
                                        :data="node" :handler="doNodeActionCmd">
                      </swb-ext-dropdown>
                </span>
            </span>

        </el-tree>
    </div>
</template>
<script>
    // last modified by koqiui
    import {Jqext, Utils} from '../../app.base'
    import SwbExtDropdown from './ExtDropdown'

    let Toast = Jqext.Toast;

    const defTreeProps = {
        //节点标签属性名
        label: 'label', //string, function(data, node)
        //子节点列表属性名
        children: 'children'
        //指定节点是否为叶子节点（仅在指定了 lazy 属性的情况下生效）
        //isLeaf: function(data, node) => boolean
        //指定节点选择框是否禁用的属性名
        //disabled: function(data, node) => boolean
    };

    export default {
        name: 'swb-dir-tree',
        desc: '目录树',
        components: {
            SwbExtDropdown
        },
        props: {
            // 标题文字
            title: {
                type: String,
                default: ''
            },
            //是否显示标题栏
            showTitleBar: {
                type: Boolean,
                default: true
            },
            //是否显示过滤框
            showFilterBox: {
                type: Boolean,
                default: true
            },
            //无节点时展示的文本
            emptyText: {
                type: String,
                default: ''
            },
            // 节点key属性名
            nodeKeyProp: {
                type: String,
                default: 'id'
            },
            // 节点是否允许勾选
            nodeCheckable: {
                type: Boolean,
                default: false
            },
            //节点是否允许拖拽
            nodeDraggable: {
                type: Boolean,
                default: false
            },
            //返回是否允许拖拽
            allowDragJudger: {//(draggingNode)
                type: Function,
                default: function (draggingNode) {
                    return true;
                }
            },
            //返回是否允许投放（dropType : before、after、inner）
            allowDropJudger: {//(draggingNode, dropNode, dropType)
                type: Function,
                default: function (draggingNode, dropNode, dropType) {
                    return true;
                }
            },
            //投放结果处理器（dropType : before、after、inner）
            nodeDropHandler: {//(draggingNode, dropNode, dropType)
                type: Function
            },
            //是否高亮显示当前节点
            highlightCurrent: {
                type: Boolean,
                default: true
            },
            //默认是否展开所有节点
            defaultExpandAll: {
                type: Boolean,
                default: false
            },
            //节点点击处理函数
            nodeClickHanlder: {//(data, node, viewMode)
                type: Function
            },
            //节点样式类生成函数
            nodeClassMaker: {//(data, node, viewMode)
                type: Function,
                default: function (data, node, viewMode) {
                    let className = node.isLeaf || !node.expanded ? 'el-icon-folder' : 'el-icon-folder-opened';
                    if (node.isCurrent && this.highlightCurrent) {
                        className += ' current';
                    }
                    return className;
                }
            },
            //节点菜单项生成函数
            nodeActionsMaker: {//(data, node, viewMode)
                type: Function,
                default: function (data, node, viewMode) {
                    let actions = [];

                    actions.push({
                        name: 'viewFolder',
                        text: '文件夹详情',
                        icon: 'el-icon-view'
                    });

                    if (!viewMode) {
                        actions.push({
                            name: 'addSubFolder',
                            text: '添加子文件夹',
                            icon: 'el-icon-folder-add'
                        });
                        actions.push({
                            name: 'editFolder',
                            text: '编辑文件夹',
                            icon: 'el-icon-edit-outline'
                        });
                        actions.push({
                            name: 'delFolder',
                            text: '删除文件夹',
                            icon: 'el-icon-folder-delete'
                        });
                    }

                    return actions
                }
            },
            //节点菜单项处理函数（当前节点node == null 时代表是添加一级子文件夹）
            nodeActionHander: {//(actionName, node, action)
                type: Function
            },
            //是否总是显示节点操作
            showNodeActionsAlways: {
                type: Boolean,
                default: false
            },
            //是否把节点操作显示为按钮
            showNodeActionsAsBtns: {
                type: Boolean,
                default: false
            },
            ///顶部菜单项生成函数
            topActionsMaker: {//(viewMode)
                type: Function,
                default: function (viewMode) {
                    let actions = [];

                    if (!viewMode) {
                        actions.push({
                            name: 'addL1Folder',
                            text: '一级文件夹',
                            hint: '添加一级文件夹',
                            icon: 'el-icon-folder-add'
                        });
                    }

                    return actions;
                }
            },
            //顶部菜单项处理函数
            topActionHander: {//(actionName, action)
                type: Function
            },
            //属性映射配置
            configProps: {
                type: Object,
                default: function () {
                    return Utils.merge(defTreeProps)
                }
            },
            //节点数据（数组）
            items: {//item:{id, label, children, disabled, ...}
                type: Array,
                default() {
                    return [];
                }
            },
            //是否查看模式（不能修改）
            viewMode: {
                type: Boolean,
                default: false
            },
            //是否自动设置id（如果没有id）
            autoSetIds: {
                type: Boolean,
                default: false
            },
            //自动设置id起始值
            autoIdStartVal: {
                type: Number,
                default: 10000
            }
        },
        //
        data: function () {
            return {
                autoIdNum: 0,
                //
                treeProps: {},

                filterText: '',
                //
                itemList: []
            };
        },
        watch: {
            items(newVal, oldVal) {
                this.init();
            }
        },
        created() {
            let treeProps = Utils.merge(defTreeProps);
            this.treeProps = Utils.merge(treeProps, this.configProps);
        },
        mounted() {
            this.autoIdNum = this.autoIdStartVal;
            //
            this.init();
        },
        beforeDestroy() {
            this.itemList = null;
            //
            this.treeProps = null;
        },
        //
        methods: {
            fillAllIds(itemList) {
                let nodeKeyProp = this.nodeKeyProp;
                let childrenProp = this.treeProps['children'];
                for (let i = 0, c = itemList.length; i < c; i++) {
                    let item = itemList[i];
                    if (item[nodeKeyProp] == null) {
                        item[nodeKeyProp] = ++this.autoIdNum;
                    }
                    let children = item[childrenProp];
                    if (children != null && children.length > 0) {
                        this.fillAllIds(children);
                    }
                }
            },
            removeAllIds(itemList) {
                let nodeKeyProp = this.nodeKeyProp;
                let childrenProp = this.treeProps['children'];
                for (let i = 0, c = itemList.length; i < c; i++) {
                    let item = itemList[i];
                    if (item[nodeKeyProp] != null) {
                        delete item[nodeKeyProp];
                    }
                    let children = item[childrenProp];
                    if (children != null && children.length > 0) {
                        this.removeAllIds(children);
                    }
                }
            },
            //
            init() {
                let itemList = Utils.merge([], this.items);
                if (this.autoSetIds) {
                    this.fillAllIds(itemList);
                }
                this.itemList = itemList;
            },
            doNodeFilter() {
                let filterText = (this.filterText || '').trim();
                let theTree = this.$refs.theTree;
                theTree.filter(filterText);
            },
            filterTreeNode(text, data) {
                if (text === '') return true;
                let labelProp = this.treeProps['label'] || 'label';
                let dataLabel = data[labelProp].toLowerCase();
                return dataLabel.indexOf(text.toLowerCase()) !== -1;
            },
            //
            doTopActionCmd(actionName, action) {
                action = Utils.merge(action);
                if (this.topActionHander) {
                    this.topActionHander.call(this.$parent, action.name, action);
                } else {
                    // Toast.show('点击了顶部操作【' + action.text + "】");
                    console.info(action);
                }
            },
            //
            shouldShowNodeActions(node) {
                return !node.loading && (this.showNodeActionsAlways || node.isCurrent);
            },
            doNodeActionCmd(actionName, node, action) {
                action = Utils.merge(action);
                if (this.nodeActionHander) {
                    this.nodeActionHander.call(this.$parent, action.name, node, action);
                } else {
                    // Toast.show('点击了节点操作【' + action.text + "】");
                    console.info(action);
                }
            },
            //TODO 把单击 和 双击分开，实现双击事件
            handleNodeClick(data, node) {
                data = Utils.merge(data);
                if (this.nodeClickHanlder) {
                    this.nodeClickHanlder.call(this.$parent, data, node, this.viewMode);
                } else {
                    // Toast.show('点击了节点【' + node.label + "】");
                    console.info(node);
                }
            },
            //TODO 有bug，不管当前节点有没有切换，都会触发（不应该的）
            handleCurrentChange(data, node) {
                //console.log(node);
            },
            //------------------------------------------------
            handleDragStart(node, ev) {
                console.log(node.label, ' drag start');
            },
            handleDragEnter(draggingNode, dropNode, ev) {
                console.log(draggingNode.label, ' enter ', dropNode.label);
            },
            handleDragOver(draggingNode, dropNode, ev) {
                console.log(draggingNode.label, ' over ', dropNode.label);
            },
            handleDragLeave(draggingNode, dropNode, ev) {
                console.log(draggingNode.label, ' leave ', dropNode.label);
            },
            handleDragEnd(draggingNode, dropNode, dropType, ev) {
                console.log(draggingNode.label, ' end @ ', dropNode && dropNode.label, dropType);
            },
            handleDrop(draggingNode, dropNode, dropType, ev) {
                if (this.nodeDropHandler) {
                    nodeDropHandler.call(this.$parent, draggingNode, dropNode, dropType);
                } else {
                    console.log(draggingNode.label, ' dropped at ', dropNode.label, dropType);
                }
            },
            //------------------------------------------------
            setCurrentKey(nodeKey) {
                let theTree = this.$refs.theTree;
                theTree.setCurrentKey(nodeKey);
            },
            getCurrentKey() {
                let theTree = this.$refs.theTree;
                return theTree.getCurrentKey();
            },
            getCurrentNode() {
                let theTree = this.$refs.theTree;
                return theTree.getCurrentNode();
            },
            getNodeByKey(nodeKey) {
                let theTree = this.$refs.theTree;
                return theTree.getNode(nodeKey);
            },
            appendNode(data, parentNodeKey) {
                let theTree = this.$refs.theTree;
                theTree.append(data, parentNodeKey);
            },
            removeNode(nodeKey) {
                let theTree = this.$refs.theTree;
                let theNode = theTree.getNode(nodeKey);
                if (theNode != null) {
                    //检查是否为当前节点
                    let curNode = this.getCurrentNode();
                    let curData = curNode == null ? null : curNode.data;
                    let isCurrent = curNode != null && curNode.id == theNode.id;
                    //
                    theTree.remove(theNode);
                    //
                    if (isCurrent) {
                        this.nodeClickHanlder.call(this.$parent, curData, null, this.viewMode);
                    }
                }
            },
            insertNodeBefore(data, refNodeKey) {
                let theTree = this.$refs.theTree;
                theTree.insertBefore(data, refNodeKey);
            },
            insertNodeAfter(data, refNodeKey) {
                let theTree = this.$refs.theTree;
                theTree.insertAfter(data, refNodeKey);
            },
            //更新子节点数据（children == null 时会清空子节点）
            updateChildNodes(parentNodeKey, children) {
                let theTree = this.$refs.theTree;
                children = children || [];
                theTree.updateKeyChildren(parentNodeKey, children);
            },
            //
            getCheckedNodeKeys(leafOnly) {
                let theTree = this.$refs.theTree;
                leafOnly = leafOnly === true;
                return theTree.getCheckedKeys(leafOnly) || [];
            },
            setCheckedNodeKeys(nodeKeys, leafOnly) {
                let theTree = this.$refs.theTree;
                nodeKeys = nodeKeys || [];
                leafOnly = leafOnly === true;
                theTree.setCheckedKeys(nodeKeys, leafOnly);
            },
            setNodeChecked(nodeKey, checked, includeDeepNodes) {
                let theTree = this.$refs.theTree;
                checked = checked !== false;
                includeDeepNodes = includeDeepNodes === true;
                theTree.setChecked(nodeKey, checked, includeDeepNodes);
            },
            //------------------------------------------------
            //获取最新的节点数据
            getCurrentItems(removeIds /* 是否删除id属性*/) {
                let itemList = Utils.merge(this.itemList);
                if (removeIds === true) {
                    this.removeAllIds(itemList);
                }
                return itemList;
            },
            //
            _getCheckedItemsInner(item, checkedProp) {
                let id = item[this.nodeKeyProp];
                let node = this.getNodeByKey(id);
                if (node.checked || node.indeterminate) {
                    let retItem = Utils.merge(item);
                    retItem[checkedProp] = node.checked; //加checked标记
                    let childrenProp = this.treeProps['children'];
                    let children = item[childrenProp];
                    if (children != null) {
                        delete retItem[childrenProp]; //删除直接复制的
                        let retChildren = [];//新的子节点数据
                        for (let i = 0, c = children.length; i < c; i++) {
                            let retChild = this._getCheckedItemsInner(children[i], checkedProp);
                            if (retChild != null) {
                                retChildren.push(retChild);
                            }
                        }
                        if (retChildren.length > 0) {
                            retItem[childrenProp] = retChildren;
                        }
                    }
                    return retItem;
                } else {
                    return null;
                }
            },
            //获取勾选的节点数据
            getCheckedItems(checkedProp /** 自定义的checked 标记属性（默认：'checked'），其值可用于区分是勾选还是半选 */, removeIds/* 是否删除id属性*/) {
                let itemList = Utils.merge(this.itemList);
                //
                checkedProp = checkedProp || 'checked';
                let retItems = [];
                if (this.nodeCheckable) {
                    for (let i = 0, c = itemList.length; i < c; i++) {
                        let retItem = this._getCheckedItemsInner(itemList[i], checkedProp);
                        if (retItem != null) {
                            retItems.push(retItem);
                        }
                    }
                }
                if (removeIds === true) {
                    this.removeAllIds(retItems);
                }
                //
                return retItems;
            }
        }
    }
</script>

<style>
    .dir-tree {
        border: 1px dotted grey;
        width: 100%;
        height: 100%;
        position: relative;
    }

    .dir-tree .title-bar {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        padding: 0 4px;
        height: 42px;
        line-height: 34px;
        border-bottom: 1px dotted #EFEFEF;
        background-color: #FEFEFE;
    }

    .dir-tree .title-bar .title {
        display: inline-block;
        margin-top: 2px;
        font-weight: bold;
    }

    .dir-tree .title-bar .ctrl-blk {
        float: right;
    }

    .dir-tree .title-bar .ctrl-blk .filter {
        margin-right: 8px;
    }

    .dir-tree .title-bar .ctrl-blk .btns {
        font-size: 18px;
        margin-left: 4px;
    }

    .dir-tree .tree-ctrl {
        position: absolute;
        top: 42px;
        left: 0;
        right: 0;
        bottom: 0;
        overflow: auto;
    }

    .dir-tree .tree-ctrl.noTitleBar {
        top: 0;
    }

    .dir-tree .tree-ctrl .tree-node {
        height: 20px;
        padding-top: 2px;
        flex: 1;
        display: flex;
        align-items: center;
        justify-content: space-between;
        font-size: 14px;
        padding-right: 8px;
    }

    .dir-tree .tree-ctrl .tree-node .label {
        display: inline-block;
        width: 300px;
        line-height: 14px;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    .dir-tree .tree-ctrl .tree-node .current {
        color: navy;
        font-weight: bold;
    }

</style>



// WEBPACK FOOTER //
// src/compo/ctrl/DirTree.vue